import palette from '../palette';

export default {
  styleOverrides: {
    root: {
      color: palette.icon,
      // height: '36px',
      // width: '36px',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: 'rgba(59, 59, 59, 0.1)',
      },
    },
  },
};
